import React from "react";
import { ptBR } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { RiCalendarEventLine } from "react-icons/ri";
import * as Styles from "./DatePicker.styles";

interface Props {
  onChange: (val: any) => void;
  value: any;
  minDate?: Date | null;
  maxDate?: Date | null;
  height?: number;
  dateIcon?: "start" | "end";
  isError?: boolean;
  disabled?: boolean;
}

export const DatePicker: React.FC<Props> = (props) => {
  return (
    <Styles.LocalizationProvider
      adapterLocale={ptBR}
      dateAdapter={AdapterDateFns}
    >
      <Styles.DesktopDatePicker
        onChange={(val: any) => {
          props.onChange(val);
        }}
        value={props?.value}
        minDate={props?.minDate}
        maxDate={props?.maxDate}
        inputFormat="dd/MM/yyyy"
        disabled={props?.disabled}
        components={{
          OpenPickerIcon: () => (
            <RiCalendarEventLine
              style={{ color: props?.disabled ? "#333333" : "#333333" }}
              size={20}
            />
          ),
        }}
        InputAdornmentProps={{ position: props.dateIcon ?? "end" }}
        renderInput={(params: any) => (
          <Styles.TextField
            height={props?.height ?? 44}
            size="small"
            variant="outlined"
            {...params}
            label="Data"
            fullWidth
            sx={{
              "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                borderColor: props.isError ? "red" : "#C4C4C4",
                backgroundColor: props.disabled ? "rgba(0,0,0,0.08)" : "",
              },
            }}
          />
        )}
      />
    </Styles.LocalizationProvider>
  );
};
